module.exports = __webpack_public_path__ + "static/img/3等离子切割空间轨迹规划机器人系统.49c85b17.jpg";